module.exports = __webpack_public_path__ + "img/prev.f7764fb6.svg";